/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.17",
    versionName: "0.4.0-nightly.2026.6.17",
    versionChannel: "nightly",
    buildDate: "2026-06-17T01:12:18.435Z",
    commitHash: "b27e845d4b22735e63ade4be48efe4dbe30d8431",
};
